import React, { useCallback } from 'react';
import {
	Control,
	FieldValues,
	UseFormSetValue,
	UseFormWatch,
} from 'react-hook-form';

import { Label, ModalSelect, Select } from '@components/common';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IModalSelectOption } from '@components/common/ModalSelect/ModalSelect.types';

import { EParametersFormValues } from '../../enums';

import styles from '../HistoryCheckOptions.module.scss';

interface IHistoryCheckAwtgRanOptions {
	configTypeOptions: TSelectOption[];
	networkElementsOptions: IModalSelectOption[];
	control: Control;
	watch: UseFormWatch<FieldValues>;
	setValue: UseFormSetValue<FieldValues>;
}

const HistoryCheckAwtgRanOptions = ({
	configTypeOptions,
	networkElementsOptions,
	control,
	watch,
	setValue,
}: IHistoryCheckAwtgRanOptions) => {
	const onChangeNetworkElements = useCallback((values: IModalSelectOption[]) => {
		setValue(EParametersFormValues.networkElements, values);
	}, [setValue]);

	const isConfigTypeDisabled = !watch(EParametersFormValues.vendor);
	const isNetworkElementsDisabled = !watch(EParametersFormValues.configType) || !networkElementsOptions.length;

	return (
		<>
			<div className={styles.groupOptions}>
				<Select
					control={control}
					disabled={isConfigTypeDisabled}
					label='Configuration type'
					name={EParametersFormValues.configType}
					options={configTypeOptions}
					placeholder='Select configuration type'
					required
				/>
			</div>
			<div>
				<Label
					className={styles.sitesLabel}
					label='Network elements'
					required
				/>
				<ModalSelect
					disabled={isNetworkElementsDisabled}
					label='Select NEs'
					modalLabel='Select Network Elements'
					onChange={onChangeNetworkElements}
					options={networkElementsOptions}
					searchPlaceholder='Search by NE name'
					values={watch(EParametersFormValues.networkElements)}
				/>
			</div>
		</>
	);
};

export default HistoryCheckAwtgRanOptions;
